export default __webpack_public_path__ + "static/media/Pro-12b.6a1e27c0.png";